import { get } from './base';

const getVersion = () => get('/api/version');

export default getVersion;
